import { createRouter, createWebHistory } from 'vue-router'

// Main views
import HomeView         from '../views/HomeView.vue'
import AboutView        from '../views/AboutView.vue'
import ServicesView     from '../views/ServicesView.vue'
import BlogView         from '../views/BlogView.vue'
import BlogDetailView   from '../views/BlogDetailView.vue'
import FeaturesView     from '../views/FeaturesView.vue'
import QuoteView        from '../views/QuoteView.vue'
import TestimonialView  from '../views/TestimonialView.vue'
import ContactView      from '../views/ContactView.vue'
import ProjectsView     from '../views/ProjectsView.vue'

const routes = [
  { path: '/',            component: HomeView },
  { path: '/about',       component: AboutView },
  { path: '/services',    component: ServicesView },
  { path: '/blog',        component: BlogView },
  { path: '/blog/:slug',  component: BlogDetailView, props: true },
  { path: '/features',    component: FeaturesView },
  { path: '/quote',       component: QuoteView },
  { path: '/testimonial', component: TestimonialView },
  { path: '/contact',     component: ContactView },
  { path: '/projects',    component: ProjectsView },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top of the page
    return { top: 0 }
  }
})

export default router
